<template>
  <div class="event-modal-catalog-ad-services">
    <h2
      class="event-modal-catalog-ad-services__title"
      v-if="adServicesCatalog.length"
    >
      {{ $t("event.catalog.modal.adServices.adInCatalogTitle") }}
    </h2>

    <div
      class="event-modal-catalog-ad-services__container"
      v-if="adServicesCatalog.length"
    >
      <div
        class="event-modal-catalog-ad-services__checkbox"
        v-for="service in adServicesCatalog"
        :key="service.id"
      >
        <Checkbox
          :value="hasInCatalog(service.id)"
          @input="updateAdServiceCatalog({ service, value: $event })"
          :disabled="!hasAccessToWrite"
        >
          <h3 class="event-modal-catalog-ad-services__checkbox-title">
            {{ service.title }}

            <EventModalCatalogExample
              :label="false"
              :images="service.images"
              class="_center event-modal-catalog-ad-services__checkbox-title-example"
            />
          </h3>

          <p class="event-modal-catalog-ad-services__checkbox-description">
            {{ service.description }}
          </p>

          <p
            class="event-modal-catalog-ad-services__checkbox-price"
            :class="{ _highlight: hasInCatalog(service.id) }"
          >
            <template v-if="service.errorPrice">
              <ErrorPriceCatalog />
            </template>
            <template v-else>
              {{ service.price }} {{ currencySymbol }}
            </template>
          </p>
        </Checkbox>
      </div>
    </div>

    <h2
      class="event-modal-catalog-ad-services__title"
      v-if="adServicesGuide.length"
    >
      {{ $t("event.catalog.modal.adServices.adInGuideTitle") }}
    </h2>

    <div
      class="event-modal-catalog-ad-services__container"
      v-if="adServicesGuide.length"
    >
      <div
        class="event-modal-catalog-ad-services__checkbox"
        v-for="service in adServicesGuide"
        :key="service.id"
      >
        <Checkbox
          :value="hasInGuide(service.id)"
          @input="updateAdServiceGuide({ service, value: $event })"
          :disabled="!hasAccessToWrite"
        >
          <h3 class="event-modal-catalog-ad-services__checkbox-title">
            {{ service.title }}

            <EventModalCatalogExample
              :label="false"
              :images="service.images"
              class="_center event-modal-catalog-ad-services__checkbox-title-example"
            />
          </h3>

          <p class="event-modal-catalog-ad-services__checkbox-description">
            {{ service.description }}
          </p>

          <p
            class="event-modal-catalog-ad-services__checkbox-price"
            :class="{ _highlight: hasInGuide(service.id) }"
          >
            <template v-if="service.errorPrice">
              <ErrorPriceCatalog />
            </template>
            <template v-else>
              {{ service.price }} {{ currencySymbol }}
            </template>
          </p>
        </Checkbox>
      </div>
    </div>

    <h2
      class="event-modal-catalog-ad-services__title"
      v-if="adServicesOther.length"
    >
      {{ $t("event.catalog.modal.adServices.adInOtherTitle") }}
    </h2>

    <div
      class="event-modal-catalog-ad-services__container"
      v-if="adServicesOther.length"
    >
      <div
        class="event-modal-catalog-ad-services__checkbox"
        v-for="service in adServicesOther"
        :key="service.id"
      >
        <Checkbox
          :value="hasInOther(service.id)"
          @input="updateAdServiceOther({ service, value: $event })"
          :disabled="!hasAccessToWrite"
        >
          <h3 class="event-modal-catalog-ad-services__checkbox-title">
            {{ service.title }}

            <EventModalCatalogExample
              :label="false"
              :images="service.images"
              class="_center event-modal-catalog-ad-services__checkbox-title-example"
            />
          </h3>

          <p class="event-modal-catalog-ad-services__checkbox-description">
            {{ service.description }}
          </p>

          <p
            class="event-modal-catalog-ad-services__checkbox-price"
            :class="{ _highlight: hasInOther(service.id) }"
          >
            <template v-if="service.errorPrice">
              <ErrorPriceCatalog />
            </template>
            <template v-else>
              {{ service.price }} {{ currencySymbol }}
            </template>
          </p>
        </Checkbox>
      </div>

      <details class="note" open style="width: 100%; flex-shrink: 0">
        <summary class="note__summary">
          <span class="note__summary-text">
            {{ locale === "en" ? "Note" : "Примечание" }}
          </span>
        </summary>

        <p class="text-description" style="margin-top: 1em;">
          {{ $t("event.catalog.modal.adServices.additionalApprovalNote") }}
        </p>
      </details>
    </div>

    <p
      v-if="
        !adServicesCatalog.length &&
          !adServicesGuide.length &&
          !adServicesOther.length
      "
    >
      {{ $t("event.catalog.modal.adServices.noAdServicesMessage") }}
    </p>
  </div>
</template>

<script>
import { Checkbox } from "@v2/shared/ui/components";
import EventModalCatalogExample from "./EventModalCatalogExample.vue";

import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

import apiCatalog from "@/api/catalog";

import { i18n } from "@v2/shared/config";
import ErrorPriceCatalog from "@/components/Modal/Catalog/ErrorPriceCatalog.vue";

export default {
  name: "EventModalCatalogAdServicesForm",

  components: {
    ErrorPriceCatalog,
    Checkbox,
    EventModalCatalogExample
  },

  computed: {
    ...mapState("event", ["event"]),
    ...mapState("eventCatalog", ["adServices"]),

    ...mapGetters("event", ["hasAccessToWrite", "eventId"]),

    ...mapGetters("eventCatalog", [
      "adServicesCatalog",
      "adServicesGuide",
      "adServicesOther",
      "currencySymbol",
      "getOrderDataFromCatalog"
    ]),

    locale() {
      return i18n.locale;
    }
  },

  methods: {
    ...mapMutations("event", ["UPDATE_CATALOG_STATUS"]),

    hasInCatalog(serviceId) {
      return this.adServices.catalog.indexOf(serviceId) > -1;
    },

    hasInGuide(serviceId) {
      return this.adServices.guide.indexOf(serviceId) > -1;
    },

    hasInOther(serviceId) {
      return this.adServices.other.indexOf(serviceId) > -1;
    },

    ...mapActions("eventCatalog", [
      "updateAdServiceCatalog",
      "updateAdServiceGuide",
      "updateAdServiceOther"
    ])
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-modal-catalog-ad-services {
  &__title {
    @include h2();
    margin-bottom: 31px;
  }

  &__container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 30px;
  }

  &__checkbox {
    width: 380px;

    @include respond-down(lg) {
      width: 350px;
    }

    margin-bottom: 27px;

    &-title {
      font-size: 13px;
      font-weight: normal;
      line-height: 1.54;
      color: #000000;

      margin: 0 0 5px 0;

      &-example {
        position: relative;
        top: 3px;
      }
    }

    &-description {
      font-size: 12px;
      line-height: 1.33;
      color: #6d7179;

      margin: 0;
    }

    &-price {
      font-size: 14px;
      font-weight: bold;
      line-height: 1.43;
      color: #a3a8b3;
      margin: 14px 0 0 0;

      &._highlight {
        color: #005197;
      }
    }
  }
}
</style>
